import useAxios, { configure, Options } from 'axios-hooks';
import axios, { AxiosRequestConfig } from 'axios';
import { API_CONFIG } from './config';
import { getUserInfo } from './auth/utils';

const apiInstance = axios.create({
  baseURL: API_CONFIG.restApiUrl,
  timeout: 10000,
  headers: {
    ...API_CONFIG.additionalHeaders,
  },
});

configure({ axios: apiInstance });

export const useApi = <TResponse = any, TBody = any>(
  config: AxiosRequestConfig<TBody>,
  options: Options = {}
) => {
  const userInfo = getUserInfo();
  const token = userInfo?.token;
  return useAxios<TResponse, TBody>(
    {
      ...config,
      headers: {
        ...config.headers,
        authorization: token ? `Bearer ${token}` : '',
      },
    },
    options,
  );
};